import React, { useState, useEffect, useRef } from 'react';
import '../css/categoryDropdown.css';

const CategoryDropdown = ({ options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    if (onSelect) {
      onSelect(option);
    }
  };

  return (
    <div className="category-dropdown-container w-md-75" ref={dropdownRef}>
      <label className="form-ip col h-100">
        <div className="selectNor">
          <div className={`custom-select h-100 ${isOpen ? 'open' : ''}`}>
            <div className="select-selected h-100" onClick={toggleDropdown}>
              <span className="select-text">
                {selectedOption ? selectedOption.label : options[0].label}
              </span>
              <span className="select-arrow">
                <b></b>
              </span>
            </div>
            {isOpen && (
              <div className="select-items">
                {options.map((option, index) => (
                  <div
                    key={index}
                    className={`select-option ${selectedOption?.value === option.value ? 'active' : ''}`}
                    onClick={() => handleOptionClick(option)}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </label>
    </div>
  );
};

export default CategoryDropdown;